import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import { LoadDTO } from '../../data/LoadDTO';
import { AnchorButton, Button, TextBox } from '@superdispatch/ui-lab';
import { Stack, useResponsiveValue } from '@superdispatch/ui';
import { trackEvent } from 'shared/helpers/Analytics';
import { useEffect } from 'react';

function CancelLoadGatepassDialogContent({
  load,
  onClose,
}: {
  load: LoadDTO;
  onClose: () => void;
}) {
  const isMobile = useResponsiveValue(true, false);
  const [customer] = load.customer.venue.contacts;

  useEffect(() => {
    trackEvent(
      'Carrier attempted to cancel load after location protected attachment opened',
    );
  }, []);

  return (
    <>
      <DialogTitle>Contact {load.customer.venue.name}</DialogTitle>
      <DialogContent>
        <TextBox>
          This load cannot be canceled because a location-protected file has
          been opened. Contact the shipper at {customer?.email} or call{' '}
          {customer?.phone} to cancel this load.{' '}
        </TextBox>
      </DialogContent>
      <DialogActions>
        {isMobile ? (
          <Stack space="large" align="right">
            {customer?.email && (
              <AnchorButton
                href={`mailto:${customer.email}`}
                variant="text"
                onClick={onClose}
              >
                EMAIL SHIPPER
              </AnchorButton>
            )}
            {customer?.phone && (
              <AnchorButton
                href={`tel:${customer.phone}`}
                variant="text"
                onClick={onClose}
              >
                CALL SHIPPER
              </AnchorButton>
            )}
            <Button variant="text" onClick={onClose}>
              CLOSE
            </Button>
          </Stack>
        ) : (
          <Button onClick={onClose}>Got It</Button>
        )}
      </DialogActions>
    </>
  );
}

export function CancelLoadGatepassDialog({
  open,
  onClose,
  load,
}: {
  open: boolean;
  onClose: () => void;
  load: LoadDTO;
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <CancelLoadGatepassDialogContent load={load} onClose={onClose} />
    </Dialog>
  );
}
